/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { ListByPlatformConnectionQueryResponse, ListByPlatformConnectionPathParams } from "../models/ListByPlatformConnection";

export function getListByPlatformConnectionUrl(platform: ListByPlatformConnectionPathParams["platform"]) {
  const res = { method: 'GET', url: `/connections/${platform}` as const }
  return res
}

/**
 * @summary Get all connection for a given platform
 * {@link /connections/:platform}
 */
export async function listByPlatformConnection(platform: ListByPlatformConnectionPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListByPlatformConnectionQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListByPlatformConnectionUrl(platform).url.toString(), ... requestConfig })
  return res.data
}